import { createSelector } from "reselect";
import get from "lodash/get";

const globalFormatSetting = state =>
  get(state, "api.appGlobalSettings.data", []);

export const globalFormatSelector = createSelector(
  globalFormatSetting,
  globalFormat => globalFormat
);

export const makeSelectGlobalFormatSelector = () => globalFormatSelector;
